module.exports = __webpack_public_path__ + "img/product-preview-27.ba2c7bd.png";